import { FC } from 'react';
import { useTenantID } from '@/hooks/useTenantID';
import Button from '../core/Button';
import { UserDTO } from '@/api/trafikportalen';
import { CurrentUserBadge } from '@/components/CurrentUserBadge';

interface Props {
  administrator: UserDTO;
  currentUserEmail?: string;
}

export const SystemAdministratorListItem: FC<Props> = ({
  administrator,
  currentUserEmail,
}) => {
  const tenantId = useTenantID();

  const { id, firstname, lastname, email } = administrator;
  const isCurrentUser = currentUserEmail && email === currentUserEmail;

  return (
    <Button
      key={id}
      to="/$tenantId/system-administrators/$systemadministratorId"
      params={{
        tenantId,
        systemadministratorId: id,
      }}
      className="h-fit w-full min-w-0 flex-col items-start gap-0 overflow-hidden truncate p-3 text-left font-normal"
    >
      <div className="flex w-full items-center justify-between gap-2">
        <p className="w-full truncate">
          {firstname} {lastname}
        </p>
        {isCurrentUser && <CurrentUserBadge className="ml-2" />}
      </div>
      <p className="w-full truncate text-text-800">{email}</p>
    </Button>
  );
};
